<!-- A chip to display a daterange to pick as a preset.

Depends on mixins/timing.js and an object from the store.

-->

<template>
  <div v-if="relevant">
    <div
      v-if="showLabel"
      class="grey--text text--darken-2 caption"
    >
      {{ $t('setTimingFromRemembered') }}:
    </div>
    <v-chip
      v-model="lastInitialDatesChipTrigger"
      color="msr"
      small
      outline
      class="clickable mr-0 mb-0"
      :title="$t('setTimingFromRemembered')"
      @click="
        emitSetDates(
          $store.getters.lastInitialDates.start,
          $store.getters.lastInitialDates.stop
        )
      "
    >
      {{ lastInitialDates.start | dayjs('DD.MM.YYYY') }} -
      {{ lastInitialDates.stop | dayjs('DD.MM.YYYY') }}
    </v-chip>
  </div>
</template>

<script>
import timing from '@/mixins/timing.js';

export default {
  name: 'LastInitialDatesChip',
  mixins: [timing],
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // Only exists to detect the 'close' event of the dates v-chip.
      lastInitialDatesChipTrigger: true,
    };
  },
  computed: {
    lastInitialDates() {
      return this.$store.getters.lastInitialDates;
    },
    /**
     * We don't want to show a daterange from the past.
     */
    relevant() {
      const dates = this.$store.getters.lastInitialDates;
      let stopDate = new Date(dates.stop);
      if (!stopDate) {
        return false;
      }
      stopDate = this.subtractOneDayFromDate(stopDate);

      const now = new Date();
      now.setHours(0, 0, 0, 0);

      const isPast = stopDate < now;
      return !isPast;
    },
  },
  watch: {
    /**
     * If this changes, the user has clicked 'close' on the chip: We
     * then want to 'forget' the last initial dates, which will also
     * make the chip disappear. Reset this trigger value afterwards,
     * so there is a chance for the chip to be displayed again once
     * the user has set another daterange.
     */
    lastInitialDatesChipTrigger: function (val) {
      this.forgetLastInitialDates();
      this.lastInitialDatesChipTrigger = true;
    },
  },
  methods: {
    emitSetDates(startDate, stopDate) {
      this.$emit('set-dates', startDate, stopDate);
    },
  },
};
</script>

<style>
.v-chip.clickable > .v-chip__content:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/LastInitialDatesChip.vue